import { EVENT } from "@/constants/event";
import useAppStore from "@/context/store";
import classNames from "classnames";
import { useCallback, useState } from "react";
import { Case, Switch } from "react-if";
import HBIcon from "../HBIcon";
import styles from "./index.module.less";

// export default function QuestionaireCard({ className, record }) {
//   const user = useAppStore(({ user }) => user);
//   const [success, setSuccess] = useState(false);
//   const [option, setOptions] = useState("");

//   const onClose = useCallback(
//     (evt) => {
//       evt.preventDefault();
//       const pinId = record.pin_id;
//       // 判断是否是采集还是其他类型
//       if (pinId) {
//         window.dispatchEvent(
//           new CustomEvent(EVENT.DELETE_PIN, { detail: pinId })
//         );
//       }
//     },
//     [record]
//   );

//   const onSelect = useCallback((answer) => {
//     setOptions(answer.title);
//     setSuccess(true);
//   }, []);

//   return (
//     <div
//       className={styles.card}
//       data-gd-expose="questionnaire_expose"
//       data-questionnaire-id={record.id}
//       data-questionnaire-title={record.title}
//       data-questionnaire-type="用户反馈"
//     >
//       <div
//         className={classNames([
//           styles.container,
//           success ? styles.showSuccess : null,
//         ])}
//       >
//         <HBIcon className={styles.close} type="ic_close" onClick={onClose} />
//         <div className={styles.content}>
//           <div className={styles.title}>{record?.title || ""}</div>
//           <div className={styles.list}>
//             {record?.answers?.map((answer) => (
//               <div
//                 className={styles.item}
//                 key={answer.title}
//                 data-gd-click="questionnaire_click"
//                 data-questionnaire-id={record.id}
//                 data-questionnaire-title={record.title}
//                 data-options-title={answer.title}
//                 data-click-type="提交"
//                 data-questionnaire-type="用户反馈"
//                 onClick={() => onSelect(answer)}
//               >
//                 <div className={styles.icon}>
//                   <img src={answer.img} alt={answer.title} />
//                 </div>
//                 <div className={styles.text}>{answer.title}</div>
//               </div>
//             ))}
//           </div>
//         </div>
//         <div className={styles.success}>
//           <div className={styles.img}>
//             <img
//               src="//cdn.dancf.com/fe-assets/20230803/1f01f1241c61a0d0d9a6ce913d57924f.png"
//               alt="感谢你的反馈"
//             />
//           </div>
//           <div className={styles.title}>感谢你的反馈</div>
//           <form method="post" action="https://support.qq.com/product/30852">
//             <input
//               type="hidden"
//               name="customInfo"
//               value={`用户ID：${user?.user_id}；问题：${
//                 record?.title || ""
//               }；选项：${option}`}
//             />
//             <button className={styles.link} type="submit">
//               继续反馈或吐槽
//             </button>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// }

export default function QuestionaireCard({ record, distCodes, fileIds }) {
  const user = useAppStore(({ user }) => user);
  const [progress, setProgress] = useState(0);
  const [answer, setAnswer] = useState(null);

  const onSelectAnswer = useCallback((answer) => {
    setProgress(1);
    setAnswer(answer);
  }, []);

  const onSelectOption = useCallback(() => {
    setProgress(2);
  }, []);

  const onSatisfy = useCallback(() => {
    setProgress(2);
  }, []);

  const onClose = useCallback(
    (evt) => {
      evt.preventDefault();
      const pinId = record.pin_id;
      // 判断是否是采集还是其他类型
      if (pinId) {
        window.dispatchEvent(
          new CustomEvent(EVENT.DELETE_PIN, { detail: pinId })
        );
      }
    },
    [record]
  );

  return (
    <div
      className={styles.card}
      data-gd-expose="questionnaire_expose"
      data-questionnaire-id={record.id}
      data-questionnaire-title="搜索结果满意度调查"
      data-questionnaire-type="用户反馈"
      data-create-id={record.id}
      data-create-title={record.name}
    >
      <div className={styles.container}>
        <HBIcon className={styles.close} type="ic_close" onClick={onClose} />
        <Switch>
          <Case condition={progress === 0}>
            <div className={styles.content}>
              <div className={styles.title}>内容质量反馈</div>
              <div
                className={classNames([
                  styles.list,
                  record?.answers?.length <= 3 ? styles.line : null,
                ])}
              >
                <div
                  className={styles.item}
                  title="满意"
                  data-gd-click="questionnaire_click"
                  data-questionnaire-id={record.id}
                  data-questionnaire-title="你对当前结果满意吗？"
                  data-options-title="满意"
                  data-click-type="提交"
                  data-questionnaire-type="用户反馈"
                  data-primary-filter-title="满意"
                  data-file-ids={fileIds?.join(",") || ""}
                  data-distcodes={distCodes?.join(",") || ""}
                  data-create-id={record.id}
                  data-create-title={record.name}
                  data-satisfaction-degree="满意"
                  data-search-word={record.search_word || ""}
                  onClick={onSatisfy}
                >
                  <div className={styles.text}>满意</div>
                </div>
                {record?.answers?.map((answer, index) => (
                  <div
                    className={classNames([
                      styles.item,
                      answer?.title?.length > 6 ? styles.long : null,
                    ])}
                    key={index}
                    onClick={() => onSelectAnswer(answer)}
                    title={answer?.title || ""}
                    data-gd-click="questionnaire_click"
                    data-questionnaire-id={record.id}
                    data-questionnaire-title="内容质量反馈"
                    data-options-title={answer?.title || ""}
                    data-click-type="提交"
                    data-questionnaire-type="用户反馈"
                    data-primary-filter-title="不满意"
                    data-second-filter-title={answer?.title || ""}
                    data-file-ids={fileIds?.join(",") || ""}
                    data-distcodes={distCodes?.join(",") || ""}
                    data-create-id={record.id}
                    data-create-title={record.name}
                    data-satisfaction-degree="不满意"
                    data-feedback-content={answer?.title || ""}
                    data-search-word={record.search_word || ""}
                  >
                    <div className={styles.text}>{answer?.title || ""}</div>
                  </div>
                ))}
              </div>
            </div>
          </Case>
          <Case condition={progress === 1}>
            <div className={styles.content}>
              <div
                className={classNames([styles.title, styles.row2])}
                title={answer?.question || ""}
              >
                {answer?.question || ""}
              </div>
              <div
                className={classNames([
                  styles.list,
                  answer?.options?.length <= 4 ? styles.line : null,
                ])}
              >
                {answer?.options?.map((option, index) => (
                  <div
                    className={classNames([
                      styles.item,
                      option?.value?.length > 6 ? styles.long : null,
                    ])}
                    key={index}
                    title={option?.question}
                    data-gd-click="questionnaire_click"
                    data-questionnaire-id={record.id}
                    data-questionnaire-title={answer?.question || ""}
                    data-options-title={option?.value || ""}
                    data-click-type="提交"
                    data-questionnaire-type="用户反馈"
                    data-primary-filter-title="不满意"
                    data-second-filter-title={answer?.title || ""}
                    data-third-filter-title={option?.value || ""}
                    data-file-ids={fileIds?.join(",") || ""}
                    data-distcodes={distCodes?.join(",") || ""}
                    data-create-id={record.id}
                    data-create-title={record.name}
                    data-satisfaction-degree="不满意"
                    data-feedback-content={answer?.title || ""}
                    data-feedback-type={option?.value || ""}
                    data-search-word={record.search_word || ""}
                    onClick={onSelectOption}
                  >
                    <div className={styles.text}>{option?.value || ""}</div>
                  </div>
                ))}
              </div>
            </div>
          </Case>
          <Case condition={progress === 2}>
            <div className={styles.success}>
              <div className={styles.img}>
                <img
                  src="https://cdn.dancf.com/fe-assets/20231019/2c461c8f0bdc22cff6156bc2698228fb.png"
                  alt="感谢你的反馈"
                />
              </div>
              <div className={styles.title}>
                感谢你的反馈，我们会尽快优化，为您推荐更好的内容
              </div>
              <form method="post" action="https://support.qq.com/product/30852">
                <input
                  type="hidden"
                  name="customInfo"
                  value={`用户ID：${user?.user_id}`}
                />
                <button className={styles.link} type="submit">
                  反馈更多问题和意见
                </button>
              </form>
            </div>
          </Case>
        </Switch>
      </div>
    </div>
  );
}
